// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_Jdm","cls2":"ImpactNavBar-cls2_OFD ImpactNavBar-cls1_Jdm"};